"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ol = require("openlayers");
// declare const ol:any;
var tj = require('togeojson');
var shp = require('gs-shapefile2geojson');
;
var emptyGeoJson = {
    type: "FeatureCollection",
    features: []
};
function updateExtent(ex, p) {
    if (p[0] < ex[0]) {
        ex[0] = p[0];
    }
    ;
    if (p[1] < ex[1]) {
        ex[1] = p[1];
    }
    ;
    if (p[0] > ex[2]) {
        ex[2] = p[0];
    }
    ;
    if (p[1] > ex[3]) {
        ex[3] = p[1];
    }
    ;
}
function parseXml(data) {
    // if ((<any>window).DOMParser) {
    return (new window.DOMParser()).parseFromString(data, "text/xml");
    // } else if (typeof window.ActiveXObject != "undefined" && new window.ActiveXObject("Microsoft.XMLDOM")) {
    //     var xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
    //         xmlDoc.async = "false";
    //         xmlDoc.loadXML(xmlStr);
    //         return xmlDoc;
    // } else {
    //    return null; 
    // }
}
function create(map, divId, layerListDivId) {
    var div = document.getElementById(divId);
    var layerListDiv;
    if (layerListDivId) {
        layerListDiv = document.getElementById(layerListDivId);
        createLayerTableHeader(layerListDiv);
    }
    div.addEventListener('drop', function (event) {
        event.preventDefault();
        var data = event.dataTransfer.getData("text");
        var files = event.dataTransfer.files; // FileList object.
        var extent = [Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER];
        var _loop_1 = function (i, f) {
            console.log(f.type);
            var type = f.type;
            var name_1 = f.name;
            // if (type === 'application/json' || type.includes('kml')) {
            var reader = new FileReader();
            reader.onload = (function (theFile) {
                return function (e) {
                    var geojson = emptyGeoJson;
                    if (type.includes('kml')) {
                        var kml = parseXml(e.target.result);
                        geojson = tj.kml(kml, { styles: true });
                        console.log(geojson);
                    }
                    else if (type.includes('shp') || name_1.toLowerCase().includes('shp')) {
                        // console.log(e.target.result);
                        geojson = shp(e.target.result);
                        console.log(geojson);
                    }
                    else {
                        geojson = JSON.parse(e.target.result);
                    }
                    var layer = new ol.layer.Vector({
                        source: new ol.source.Vector()
                    });
                    geojson.features.forEach(function (f) {
                        if (f.geometry.type === "LineString") {
                            var geom = new ol.geom.LineString(f.geometry.coordinates);
                            geom.transform('EPSG:4326', 'EPSG:3857');
                            geom.getCoordinates().forEach(function (c) {
                                updateExtent(extent, c);
                            });
                            var feature = new ol.Feature(geom);
                            feature.setStyle(style('red', 1, 5, 24));
                            layer.getSource().addFeatures([feature]);
                        }
                        if (f.geometry.type === "MultiLineString") {
                            var geom = new ol.geom.MultiLineString(f.geometry.coordinates);
                            geom.transform('EPSG:4326', 'EPSG:3857');
                            geom.getCoordinates().forEach(function (c) {
                                c.forEach(function (c) {
                                    updateExtent(extent, c);
                                });
                            });
                            var feature = new ol.Feature(geom);
                            feature.setStyle(style('red', 1, 5, 24));
                            layer.getSource().addFeatures([feature]);
                        }
                        if (f.geometry.type === "Point") {
                            var geom = new ol.geom.Point(f.geometry.coordinates);
                            geom.transform('EPSG:4326', 'EPSG:3857');
                            updateExtent(extent, geom.getCoordinates());
                            var feature = new ol.Feature(geom);
                            feature.setStyle(style('red', 1, 5, 24, f.properties.name));
                            feature.setProperties(f.properties);
                            layer.getSource().addFeatures([feature]);
                        }
                        if (f.geometry.type === "Polygon") {
                            var geom = new ol.geom.Polygon(f.geometry.coordinates);
                            geom.transform('EPSG:4326', 'EPSG:3857');
                            geom.getCoordinates().forEach(function (c) {
                                c.forEach(function (c) {
                                    updateExtent(extent, c);
                                });
                            });
                            var feature = new ol.Feature(geom);
                            feature.setStyle(style('red', 1, 5, 24, f.properties.name));
                            feature.setProperties(f.properties);
                            layer.getSource().addFeatures([feature]);
                        }
                    });
                    map.addLayer(layer);
                    var center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
                    map.getView().setCenter(center);
                    addLayerListEntry(layer, name_1, layerListDiv);
                };
            })(f);
            // Read in the image file as a data URL.
            // reader.readAsDataURL(f);
            if (type.includes('shp') || name_1.toLowerCase().includes('shp')) {
                reader.readAsArrayBuffer(f);
            }
            else {
                reader.readAsText(f);
            }
            // }
        };
        for (var i = 0, f = void 0; f = files[i]; i++) {
            _loop_1(i, f);
        }
    });
    div.addEventListener('dragover', function (event) {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    div.addEventListener('dragenter', function (event) {
        event.preventDefault();
        return true;
    });
    div.addEventListener('dragstart', function (event) {
        return true;
    });
}
exports.create = create;
function style(color, lineWidth, pointRadius, textHeight, text) {
    var textStyle = new ol.style.Text({
        // font: `normal ${10 * this.pixelSizeFactor}px Arial`,
        font: "normal " + textHeight + "px Arial",
        text: text,
        stroke: new ol.style.Stroke({
            color: 'white',
            width: lineWidth
        }),
        textAlign: 'center',
        offsetX: 0,
        offsetY: 0,
        rotation: 0 // vertical ? 3 * Math.PI / 2 : 0
    });
    var style_ = {
        image: new ol.style.Circle({
            radius: pointRadius,
            fill: new ol.style.Fill({
                color: color
            }),
            stroke: new ol.style.Stroke({
                color: 'white',
                width: lineWidth
            })
        }),
        fill: new ol.style.Fill({
            color: color
        }),
        stroke: new ol.style.Stroke({
            color: color,
            width: lineWidth
        })
    };
    if (text) {
        style_.text = textStyle;
    }
    return new ol.style.Style(style_);
}
function createLayerTableHeader(div) {
    if (div) {
        var new_div = document.createElement('div');
        new_div.style.marginTop = "5px";
        new_div.style.marginBottom = "15px";
        var span = document.createElement('div');
        span.innerHTML = "color";
        span.style.position = "relative";
        span.style.marginLeft = "20px";
        span.style.width = "70px";
        span.style.display = "inline-block";
        span.style.fontSize = "10pt";
        span.style.cursor = "default";
        new_div.appendChild(span);
        span = document.createElement('div');
        span.innerHTML = "width";
        span.style.position = "relative";
        span.style.width = "50px";
        span.style.display = "inline-block";
        span.style.fontSize = "10pt";
        span.style.cursor = "default";
        new_div.appendChild(span);
        span = document.createElement('div');
        span.innerHTML = "radius";
        span.style.position = "relative";
        span.style.width = "50px";
        span.style.display = "inline-block";
        span.style.fontSize = "10pt";
        span.style.cursor = "default";
        new_div.appendChild(span);
        span = document.createElement('div');
        span.innerHTML = "text";
        span.style.position = "relative";
        span.style.width = "60px";
        span.style.display = "inline-block";
        span.style.fontSize = "10pt";
        span.style.cursor = "default";
        new_div.appendChild(span);
        div.appendChild(new_div);
    }
}
function addLayerListEntry(layer, name, div) {
    if (div) {
        var new_div = document.createElement('div');
        new_div.style.marginTop = "5px";
        var onOff = document.createElement('input');
        onOff.type = "checkbox";
        onOff.style.height = "14px";
        onOff.style.width = "20px";
        onOff.style.margin = "0px";
        onOff.checked = true;
        onOff.addEventListener("change", function (event) {
            var value = event.target.checked;
            layer.setVisible(value);
        });
        new_div.appendChild(onOff);
        var colorSelect_1 = document.createElement('select');
        colorSelect_1.style.marginRight = "10px";
        colorSelect_1.style.width = "60px";
        colorSelect_1.innerHTML = "\n            <option value= \"red\">red</option>\n            <option value= \"white\">white</option>\n            <option value= \"black\">black</option>\n            <option value= \"blue\">blue</option>\n        ";
        colorSelect_1.title = 'color';
        colorSelect_1.addEventListener('change', function (event) {
            layer.getSource().getFeatures().forEach(function (feature) {
                feature.setStyle(style(colorSelect_1.value, parseInt(lineWidthSelect_1.value), parseInt(pointRadiusSelect_1.value), parseInt(textHeightSelect_1.value), feature.getProperties()['name']));
            });
        });
        new_div.appendChild(colorSelect_1);
        var lineWidthSelect_1 = document.createElement('select');
        lineWidthSelect_1.style.marginRight = "10px";
        lineWidthSelect_1.style.width = "40px";
        lineWidthSelect_1.innerHTML = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(function (v) { return "\n            <option value= \"" + v + "\">" + v + "</option>\n        "; }).join('');
        colorSelect_1.title = 'line width';
        lineWidthSelect_1.addEventListener('change', function (event) {
            layer.getSource().getFeatures().forEach(function (feature) {
                feature.setStyle(style(colorSelect_1.value, parseInt(lineWidthSelect_1.value), parseInt(pointRadiusSelect_1.value), parseInt(textHeightSelect_1.value), feature.getProperties()['name']));
            });
        });
        new_div.appendChild(lineWidthSelect_1);
        var pointRadiusSelect_1 = document.createElement('select');
        pointRadiusSelect_1.style.marginRight = "10px";
        pointRadiusSelect_1.style.width = "40px";
        pointRadiusSelect_1.innerHTML = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(function (v) { return "\n            <option value= \"" + v + "\">" + v + "</option>\n        "; }).join('');
        pointRadiusSelect_1.selectedIndex = 4;
        pointRadiusSelect_1.title = 'point radius';
        pointRadiusSelect_1.addEventListener('change', function (event) {
            layer.getSource().getFeatures().forEach(function (feature) {
                feature.setStyle(style(colorSelect_1.value, parseInt(lineWidthSelect_1.value), parseInt(pointRadiusSelect_1.value), parseInt(textHeightSelect_1.value), feature.getProperties()['name']));
            });
        });
        new_div.appendChild(pointRadiusSelect_1);
        var textHeightSelect_1 = document.createElement('select');
        textHeightSelect_1.style.marginRight = "10px";
        textHeightSelect_1.style.width = "50px";
        textHeightSelect_1.innerHTML = [10, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36].map(function (v) { return "\n            <option value= \"" + v + "\">" + v + "</option>\n        "; }).join('');
        textHeightSelect_1.selectedIndex = 6;
        textHeightSelect_1.title = 'text height';
        textHeightSelect_1.addEventListener('change', function (event) {
            layer.getSource().getFeatures().forEach(function (feature) {
                feature.setStyle(style(colorSelect_1.value, parseInt(lineWidthSelect_1.value), parseInt(pointRadiusSelect_1.value), parseInt(textHeightSelect_1.value), feature.getProperties()['name']));
            });
        });
        new_div.appendChild(textHeightSelect_1);
        var span = document.createElement('div');
        span.innerHTML = name;
        span.style.position = "relative";
        span.style.top = "2px";
        span.style.width = "100px";
        span.style.overflow = "hidden";
        span.style.display = "inline-block";
        span.style.fontSize = "10pt";
        span.style.textOverflow = "ellipsis";
        span.title = name;
        span.style.cursor = "default";
        // white-space: nowrap;
        new_div.appendChild(span);
        div.appendChild(new_div);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/geo-loader/dist/index.js
// module id = 9
// module chunks = 0